import '../../../assets/login.css';
import useForm from './useForm';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import InputAuth from '../../../components/UI/Input/InputAuth';

const Checkbox = (props) => {
  const { t, i18n } = useTranslation();
  const { inputHasErrors } = props;
  return (
    <>
      <input type="checkbox" className={inputHasErrors ? 'form-check-input is-invalid' : 'form-check-input'} {...props} />
      <label className="form-check-label " for="exampleCheck1">
        {t('registration.form.condition1')} <a href="#">{t('registration.form.condition2')} </a>{' '}
        {t('registration.form.condition3')} <a href="#">{t('registration.form.condition4')} </a> .
      </label>
      <div className="invalid-feedback">{t(inputHasErrors)}</div>
    </>
  );
};
const Registration = () => {
  const { t, i18n } = useTranslation();

  const { field, submitHandler, firebaseProviderRegistration, formInputs, setFormInputs, errors, loading } = useForm();

  return (
    <div className="col-lg-12 col-sm-12 login-banner registration-page">
      <div className="row d-flex justify-content-center gutter-x-0">
        <div className="col-lg-5 registration-card">
          <div className="container">
            <div className="row">
              <div className="col-12 text-center">
                <h2 className="login-card-title ">{t('registration.form.title')}</h2>
              </div>

              <div className="col-12">
                <form>
                  <div className="form-group login-form-input">
                    <InputAuth type="email" placeholder={t('registration.form.placeholderEmail')} {...field('email')} />
                  </div>

                  <div className="form-group login-form-input">
                    <InputAuth type="password" placeholder={t('registration.form.placeholderPassword')} {...field('password')} />
                  </div>

                  <div className="form-group login-form-input">
                    <InputAuth
                      type="password"
                      placeholder={t('registration.form.placeholderPasswordConfirmation')}
                      {...field('password_confirm')}
                    />
                  </div>

                  <div className="form-group form-check">
                    <Checkbox type="checkbox" {...field('conditions', 'checkbox')} />
                  </div>

                  <div className="row justify-content-md-center">
                    <div className="col-12 text-center mt-4">
                      <button
                        type="submit"
                        className="btn btn-warning  btn-block btn-lg font-weight-bold mt-4 d-flex justify-content-center"
                        onClick={submitHandler}
                        disabled={loading}
                        style={{ fontSize: '20px' }}
                      >
                        <span
                          className="spinner-border "
                          role="status"
                          aria-hidden="true"
                          style={{ display: loading === true ? 'block' : 'none' }}
                        ></span>
                        <span className=""> {t('registration.form.register')} </span>
                      </button>
                      <div className="text-danger">{t(errors)}</div>
                      <div className="text-center mt-2">
                        <span>
                          {t('registration.form.already')} <Link to="/login"> {t('registration.form.connect')} </Link>
                        </span>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Registration;
